// Mirror of farm-data-mapper.ts `isMobileOrModularRC` field-fallback
// pattern (`docs-engine/lambdas/docs-renderer/farm-data-mapper.ts`):
// real Forreston offers store the home-type discriminator on either
// `building.propertyType` (canonical staff-fe field) or the legacy
// `building.typeOfHome` field. Checking just one misses offers shaped
// the other way — the dec mapper accepts both, so staff-fe needs to
// too. (#30735 audit alignment — staff-fe display lockstep with the
// dec output for any offer shape.)
//
// Barndominium ('B') has no legacy `typeOfHome` representation in any
// historical offer we've seen, so it stays single-field.

export const isMobileHome = (building) => building?.propertyType === 'MH' || building?.typeOfHome === 'MH';

export const isModularHome = (building) => building?.propertyType === 'MD' || building?.typeOfHome === 'MD';

export const isBarndominium = (building) => building?.propertyType === 'B';
